import { ResponseWrapper, ErrorWrapper } from './utils';
import getEnv from '@/utils/env';
import axiosInstance from '@/services/api/http.service';

const API_URL = getEnv('VUE_APP_LOG_OAP_HOST') || 'http://localhost:8083';

export class CustomDBService {
  static get entity() {
    return 'dbm';
  }

  static async getGraphData(userData) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/log-metrics/histogram`,
        userData,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
